import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import css from './HelpAndDonatePage.module.css';
import help1 from './help1.jpg';

const HelpAndDonatePage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="Help & Donate"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'HelpAndDonatePage',
        description: 'Help & Donate',
        name: 'Help & Donate',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>

          <h1 className={css.pageTitle}>Help & Donate</h1>
          <img className={css.coverImage} src={help1} alt="h4ukr" />
          
          <br/>
          <p>You can help us in several ways:</p>
          <p><strong>1. Offer help by creating a listing.</strong> This can be accommodation, a job, supplies or services such as transportation or help with paperwork. To create a new listing, <a href='/l/draft/00000000-0000-0000-0000-000000000000/new/features'>click here</a> – it takes under 2 minutes.</p>
          
          <p>
            <strong>2. Make a donation.</strong> You can donate to Host4Ukraine, using our PayPal account. To access our PayPal account, <a href='https://www.paypal.com/donate/?hosted_button_id=F4R3H6SWYX636'>click here.</a>
            <br/>
            For larger donations, please reach out to us via <a href='give@host4ukraine.com'>give@host4ukraine.com</a> and we will provide you with more information and the respective bank details.
          </p>

          <p>
            <i>What happens with the donations?</i>
            <br/>
            There are quite some volunteers supporting Host4Ukraine. However, there are always bills that need to be paid. Donations will be used for platform maintenance and optimizations as well as social media campaigns to spread the word and create more awareness about Host4Ukraine for both helpers and refugees.
          </p>

          <p>
            <strong>3. Become a partner.</strong> Help us optimize, extend and maintain the platform and increase our reach. Join our network of partner organization and support us with skills, services or manpower on a voluntary basis. We are grateful for your help, feel free to reach out to us via <a href='give@host4ukraine.com'>partner@host4ukraine.com</a>  
          </p>

          <p>
          <strong>4. Spread the word.</strong> Help us to reach more helpers and refugees by writing about us, by sharing and posting on social media or by recommending Host4Ukraine to friends, family, colleagues and others. Our social media accounts can be found in the footer of the website. For press inquiries, please contact <a href='press@host4ukraine.com'>press@host4ukraine.com</a>
          </p>

           
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default HelpAndDonatePage;
